// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3hZOq","productName":"Table_productName__33kB4"};